jQuery($ => {
    class TabList {
        constructor(element) {
            this._ = element;
            this._element = $(element);
            this._list = this._element.find('.m-tab-list__list');
            this._tabs = this._element.find('.m-tab-list__tab');

            this._isAutomatic = this._list.data('automatic');

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {

            this._tabs.each((_, tab) => {
                $(tab).on('mousedown', event => {
                    this.handleTabMousedown(event, tab);
                });

                $(tab).on('keydown', event => {
                    this.handleTabKeydown(event, tab);
                });
            });
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Select
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabSelect = tab => {
            $(tab).tab('handleSelect');
            $(tab).closest('.m-tab-list__item').addClass('m-tab-list__item--selected');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Deselect
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabDeselect = tab => {
            $(tab).tab('handleDeselect');
            $(tab).closest('.m-tab-list__item').removeClass('m-tab-list__item--selected');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Click
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabMousedown = (event, tab) => {
            event.preventDefault();

            this.handleTabSelect(tab);

            this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Keydown
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabKeydown = (event, tab) => {
            switch (event.key) {
                case "Enter":
                case "spacebar":
                case " ":
                    if (!this._isAutomatic) {
                        event.preventDefault();

                        this.handleTabSelect(tab);

                        this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;

                case 'ArrowUp':
                    if (this._element.hasClass('m-tab-list--vertical')) {
                        event.preventDefault();

                        const $prevItem = $(tab)
                            .closest('.m-tab-list__item')
                            .prev();

                        if ($prevItem[0]) {
                            const $prevTab = $prevItem.find('.m-tab-list__tab');

                            $prevTab.focus();

                            if (this._isAutomatic) {
                                this.handleTabSelect($prevTab);
                                this._tabs.not($prevTab).each((_, _tab) => this.handleTabDeselect(_tab));
                            }
                        }
                    }
                    break;

                case 'ArrowLeft':
                    event.preventDefault();

                    const $prevItem = $(tab)
                        .closest('.m-tab-list__item')
                        .prev();

                    if ($prevItem[0]) {
                        const $prevTab = $prevItem.find('.m-tab-list__tab');

                        $prevTab.focus();

                        if (this._isAutomatic) {
                            this.handleTabSelect($prevTab);
                            this._tabs.not($prevTab).each((_, _tab) => this.handleTabDeselect(_tab));
                        }
                    }
                    break;

                case 'ArrowDown':
                    if (this._element.hasClass('m-tab-list--vertical')) {
                        event.preventDefault();

                        const $nextItem = $(tab)
                            .closest('.m-tab-list__item')
                            .next();

                        if ($nextItem[0]) {
                            const $nextTab = $nextItem.find('.m-tab-list__tab');

                            $nextTab.focus();

                            if (this._isAutomatic) {
                                this.handleTabSelect($nextTab);
                                this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
                            }
                        }
                    }
                    break;

                case 'ArrowRight':
                    event.preventDefault();

                    const $nextItem = $(tab)
                        .closest('.m-tab-list__item')
                        .next();

                    if ($nextItem[0]) {
                        const $nextTab = $nextItem.find('.m-tab-list__tab');

                        $nextTab.focus();

                        if (this._isAutomatic) {
                            this.handleTabSelect($nextTab);
                            this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
                        }
                    }
                    break;

                case "Home":
                    event.preventDefault();

                    const $firstTab = this._list
                        .find(".m-tab-list__item")
                        .first()
                        .find(".m-tab-list__tab");

                    $firstTab.focus();

                    if (this._isAutomatic) {
                        this.handleTabSelect($firstTab);
                        this._tabs.not($firstTab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;

                case "End":
                    event.preventDefault();

                    const $lastTab = this._list
                        .find(".m-tab-list__item")
                        .last()
                        .find(".m-tab-list__tab");

                    $lastTab.focus();

                    if (this._isAutomatic) {
                        this.handleTabSelect($lastTab);
                        this._tabs.not($lastTab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;
            }
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.tab_list = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].tab_list = new TabList(_[i], opt);
            else
                ret = _[i].tab_list[opt].apply(_[i].tab_list, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-tab-list').tab_list();
});